export default (projects, { id }) => {
  return projects.filter((project) => {
    return project.clientId === id;
  })
  // .sort(function(a, b){
  //   return b.startDate - a.startDate;
  // });
};



// WEBPACK FOOTER //
// ./src/store/selectors/clientProjects.js